import * as Yup from 'yup';
import {LanguageEnum, TitleEnum} from '../../../../enums';

export interface EditUserFormType {
    phoneNumber: string;
    language: LanguageEnum;
    title: TitleEnum;
}

export interface EditUserNameFormType {
    firstName: string;
    lastName: string;
    language: LanguageEnum;
}

export const editCompanyFormSchema = Yup.object().shape({
    businessId: Yup.string(),
    companyName: Yup.string().max(255).required('schemaRequiredCompanyName'),
    billingEmail: Yup.string().email('schemaValidEmail').max(255),
    billingAddressCountry: Yup.string().required('schemaRequiredCountry'),
    billingAddressRegion: Yup.string().required('schemaRequiredRegion'),
    billingAddressCity: Yup.string().required('schemaRequiredCity'),
    billingAddressStreet: Yup.string().max(255).required('schemaRequiredStreet'),
    billingAddressHouseNumber: Yup.string().required('schemaRequiredHouseNumber'),
    billingAddressZipCode: Yup.string().max(255).required('schemaRequiredZip'),
    contactPersonFirstName: Yup.string().max(255).required('schemaRequiredFirstName'),
    contactPersonLastName: Yup.string().max(255).required('schemaRequiredLastName'),
    contactPersonPhone: Yup.string().max(255).required('schemaRequiredPhone'),
    chargeConsumption: Yup.boolean(),
});

export const editUserNameFormSchema = Yup.object().shape({
    firstName: Yup.string().max(255).required('schemaRequiredName'),
    lastName: Yup.string().max(255).required('schemaRequiredLastName')
});

export const editUserFormSchema = Yup.object().shape({
    language: Yup.string(),
    title: Yup.string(),
    phoneNumber: Yup.string(),
});
